import makeApiCall from "./axiosIndex";
const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "Purchase Order",
      moduleFileType: "signature.png",
    },
  ],
};

const purchaseOrderApis = {
  fetchPurchaseOrders: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/order-vs-billing/fetchAllOrders",
    }),
  fetchWidgetCount: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/order-vs-billing/countOrdersByStatus",
    }),
  fetchOrder: (id: string): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/order-vs-billing/fetchOrder?orderNumber=${id}`,
    }),
  fetchAllUserApprovalOrders: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/order-vs-billing/fetchAllUserApprovalOrders",
    }),
  purchaseOrderUpdate: (orderNumber: string, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/order-vs-billing/amendmentOrder/${orderNumber}`,
      data,
    }),

  approvePo: (orderNumber: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      orderNumber,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "patch",
      url: `/order-vs-billing/approveOrder`,
      data: formData,
    });
  },

  disapprovePo: (
    orderNumber: string,
    reason: string,
    files: File[] = []
  ): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      orderNumber,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "patch",
      url: `/order-vs-billing/disapproveOrder`,
      data: formData,
    });
  },

  rejectPo: (orderNumber: string): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/order-vs-billing/rejectOrder?orderNumber=${orderNumber}`,
    }),
  fetchAllUserPendingApprovalOrders: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/order-vs-billing/fetchAllUserPendingApprovalOrders",
    }),
  rejectChangeRequestOrder: (orderNumber: string, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/order-vs-billing/rejectChangeRequestOrder?orderNumber=${orderNumber}&rejectedReason=${data}`,
    }),
  acceptChangeRequestOrder: (orderNumber: string): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/order-vs-billing/acceptChangeRequestOrder?orderNumber=${orderNumber}`,
    }),
  sendOrderEmailNotification: (orderNumber: string, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/order-vs-billing/sendOrderEmailNotification/${orderNumber}`,
      data,
    }),

  fetchDerivedOrderStatusDropdown: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/order-vs-billing/fetchDerivedOrderStatusDropdown",
    }),
  // fetchAllOrgOrdersWithPagination: (sortOrder:any ,pageSize:any ,direction:any ,pageDiff:any ,orderNumber:any): Promise<any> =>
  //   makeApiCall<any>({
  //     method: "get",
  //     url: "/order-vs-billing/fetchAllOrgOrdersWithPagination",
  //     params: { sortOrder, pageSize, direction, pageDiff, orderNumber },
  //   }),
  fetchOrderVersions: (id: string): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/order-vs-billing/fetchOrderVersions/${id}`,
    }),
  orderMaterialBulkUpload: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/order-vs-billing/orderMaterialBulkUpload",
      data,
    }),
  transferOrder: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/order-vs-billing/transferOrder",
      data,
    }),
  shortCloseOrder: (orderNumber: string): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/order-vs-billing/shortCloseOrder?orderNumber=${orderNumber}`,
    }),
};

export default purchaseOrderApis;
